import * as React from 'react';
import { DataGrid } from '@mui/x-data-grid';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Button from '@mui/material/Button';
import EditDialog from './EditDialog';
import _ from 'lodash';
import MUDialog from '../../MUDialog';
import styles from '../../../style.js';

export default class EditGrid extends React.Component{
  constructor(props){
      super(props);
      this.state = {
          gridRows: [],
          gridColumns : [],
          gridHeight:400,
          selectedIds:[],
          selectedRowData:{},
          isDialogOpen:false,
          columnVisibilityModel:{},
          deletedIds:[],
          editPage:false,
          isMainGrid:true,
          isDeleteDialogOpen:false
        };
        this.textInput = null;

        if(props.getLoadFunc!=null){
          props.getLoadFunc(this)
        }
  }

  GetRows= () => {
    return this.state.gridRows;
  }

  GetDeletedIds= () => {
    return this.state.deletedIds;
  }

  componentDidMount() {  

    if (this.props.gridHeight != undefined ) {
        this.setState( { gridHeight: this.props.gridHeight});
      }

      if (this.props.isChild != undefined &&  this.props.isChild) {
        this.setState( { isMainGrid: false});
      }
  }

  afterSetGridRows() {   
    //this.props.onGridChange(this.state.gridRows);
  }

  handleAddRow = () => {
    this.setState(
      {
        isDialogOpen:true
      });
  };

  handleUpdateRow = () => {
    const {selectedIds,gridRows} = this.state;

    if(selectedIds.length==0 || selectedIds.length>1){
      this.props.actions.setNotification("Bir kayıt seçmeniz gerekir.", 'error');
      return;
    }

    Array.prototype.forEach.call(gridRows, value => {
      if (value.id === selectedIds[0]) {
        this.setState(
          {
            isDialogOpen:true,
            selectedRowData:value,
            editPage:true
          });    
      }
    });


  };

  handleDeleteRow = () => {
    const {selectedIds,gridRows,isMainGrid} = this.state;


    if(selectedIds.length==0){
      this.props.actions.setNotification("Bir kayıt seçmeniz gerekir.", 'error');
      return;
    }

    this.setState({isDeleteDialogOpen:true});

  };

  executeDeleteRecords = async (selectedIds,crudOperation) => {
    return await Promise.all(selectedIds.map(id=>crudOperation.Delete(id)))
    .then(() => {
      this.props.LoadData();
    });
}

  

  handleCloseDialog(ele) {
    this.setState({ isDialogOpen: false,editPage:false });
  }

  handleCloseDeleteDialog(ele) {
    this.setState({ isDeleteDialogOpen: false });
  }

  handleApproveDeleteDialog(ele) {
    const {selectedIds,gridRows,isMainGrid} = this.state;
    this.setState({ isDeleteDialogOpen: false });

    
    if(!isMainGrid){
      this.setState({deletedIds: [...this.state.deletedIds, selectedIds]});
      const afterDeletedRows = gridRows.filter( currentItem => {
        return !selectedIds.find( deleteId => deleteId === currentItem.id );});
      this.setState({gridRows: afterDeletedRows}, () => {this.afterSetGridRows();});
    }
    else{
      var crudOperation= this.props.CRUD;
      this.executeDeleteRecords(selectedIds,crudOperation);
    }
  }

  handleApproveDialog(ele) {
    const {gridRows,selectedRowData,isMainGrid,editPage} = this.state;

    if(!isMainGrid){
      if(selectedRowData.id==undefined){
        selectedRowData.id=this.createId(10);
        // selectedRowData.recordStatus="N";
          this.setState({
            gridRows: [...this.state.gridRows, selectedRowData]}, () => {
              this.afterSetGridRows();
        });
      }
      else{
        Array.prototype.forEach.call(gridRows, value => {
          if (value.id === selectedRowData.id) {
            // selectedRowData.recordStatus="U";
            value=selectedRowData;
          }
        });
      }
    }
    else{
      if (!_.isNil(selectedRowData) && !_.isNil(this.props.CRUD) ) {
        if (editPage) {
          this.UpdateRecord(selectedRowData);
        }
        else{
          this.InsertRecord(selectedRowData);
        }
      }
    }

    this.setState({ isDialogOpen: false,selectedRowData:{},editPage:false });
  }

  InsertRecord(selectedData){
    var crudOperation= this.props.CRUD;

    crudOperation.Create(selectedData)
    .then((responseJson) => {
      this.props.LoadData();
      console.log(responseJson);
    }).catch((error) => {
      if (!_.isNil(error.response)) {
        if (!_.isNil(error.Message)) {
          this.props.actions.setNotification(error.Message, 'error');
        } else {
          this.props.actions.setNotification('System error occured', 'error');
        }
        return;
      }
    })
    .finally(()=>{
      this.setState({loading: false});
    });
  }

  UpdateRecord(selectedData){
    var crudOperation= this.props.CRUD;

    crudOperation.Update(selectedData.id,selectedData)
    .then((responseJson) => {
      this.props.LoadData();
      console.log(responseJson);
    }).catch((error) => {
      if (_.isNil(error.response)) {
        if (!_.isNil(error.message)) {
          this.props.actions.setNotification(error.message, 'error');
        } else {
          this.props.actions.setNotification('System error occured', 'error');
        }
        return;
      }
    })
    .finally(()=>{
      this.setState({loading: false});
    });
  }

  createId(length) {
    var result           = '';
    var characters       = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    var charactersLength = characters.length;
    for ( var i = 0; i < length; i++ ) {
        result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }
    return result;
}

  render(){
      const {gridRows,gridColumns,gridHeight,selectedRowData,isDialogOpen,columnVisibilityModel,isDeleteDialogOpen} = this.state;
      const {dialogTitle}=this.props;

      return (
        <div>
          <div>
            {
            <Box sx={{ width: '100%' }}>
              <Stack direction="row" spacing={1}>
                  
                <Button size="small" onClick={this.handleUpdateRow} sx={styles.gridUpdateBtn}>
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="24" viewBox="0 0 20 24" fill="none">
                  <path fill-rule="evenodd" clip-rule="evenodd" d="M1.53334 21.6H18.3333C18.6516 21.6 18.9568 21.7264 19.1819 21.9515C19.4069 22.1765 19.5333 22.4817 19.5333 22.8C19.5333 23.1183 19.4069 23.4235 19.1819 23.6485C18.9568 23.8736 18.6516 24 18.3333 24H1.53334C1.21508 24 0.909859 23.8736 0.684816 23.6485C0.459772 23.4235 0.333344 23.1183 0.333344 22.8C0.333344 22.4817 0.459772 22.1765 0.684816 21.9515C0.909859 21.7264 1.21508 21.6 1.53334 21.6ZM0.333344 16.0142C0.333344 15.749 0.4387 15.4946 0.626237 15.3071L11.6262 4.30711C12.0168 3.91658 12.6499 3.91658 13.0405 4.30711L15.2262 6.49289C15.6168 6.88342 15.6168 7.51658 15.2262 7.90711L4.22624 18.9071C4.0387 19.0946 3.78435 19.2 3.51913 19.2H1.33334C0.781059 19.2 0.333344 18.7523 0.333344 18.2V16.0142ZM14.24 3.10711C13.8497 2.71654 13.8498 2.08356 14.2402 1.69313L15.2262 0.707107C15.6168 0.316583 16.2499 0.316583 16.6405 0.707107L18.8262 2.89289C19.2168 3.28342 19.2168 3.91658 18.8262 4.30711L17.8395 5.29386C17.4489 5.68447 16.8155 5.68437 16.425 5.29362L14.24 3.10711Z" fill="#A9AABC"/>
                </svg> 
                {/* Düzenle */}
                </Button>
                <Button size="small" onClick={this.handleDeleteRow} sx={styles.gridDeleteBtn}>
                <svg xmlns="http://www.w3.org/2000/svg" width="19" height="24" viewBox="0 0 19 24" fill="none">
                  <path fill-rule="evenodd" clip-rule="evenodd" d="M11.8184 6.96227e-08C12.2458 0.000130632 12.6623 0.158743 13.009 0.453369C13.3556 0.747996 13.6148 1.1637 13.7499 1.6416L14.3028 3.6H17.6424C17.9124 3.6 18.1714 3.72643 18.3624 3.95147C18.5533 4.17652 18.6606 4.48174 18.6606 4.8C18.6606 5.11826 18.5533 5.42348 18.3624 5.64853C18.1714 5.87357 17.9124 6 17.6424 6L17.6393 6.0852L16.7566 20.6568C16.7015 21.5647 16.3566 22.4144 15.7914 23.0347C15.2261 23.655 14.4825 23.9999 13.7102 24H5.28371C4.51138 23.9999 3.76775 23.655 3.20252 23.0347C2.63728 22.4144 2.29241 21.5647 2.23731 20.6568L1.35455 6.084C1.35271 6.05605 1.35169 6.02803 1.35149 6C1.08146 6 0.822478 5.87357 0.631531 5.64853C0.440585 5.42348 0.333313 5.11826 0.333313 4.8C0.333313 4.48174 0.440585 4.17652 0.631531 3.95147C0.822478 3.72643 1.08146 3.6 1.35149 3.6H4.69113L5.244 1.6416C5.37911 1.16351 5.63848 0.747662 5.98534 0.453018C6.3322 0.158374 6.74895 -0.000121273 7.17651 6.96227e-08H11.8184ZM6.4424 9.6C6.19302 9.60004 5.95231 9.70795 5.76595 9.90326C5.57959 10.0986 5.46053 10.3677 5.43135 10.6596L5.42422 10.8V18C5.42451 18.3059 5.52388 18.6 5.70203 18.8224C5.88018 19.0448 6.12367 19.1787 6.38273 19.1966C6.6418 19.2145 6.8969 19.1152 7.09591 18.9189C7.29491 18.7226 7.42281 18.4441 7.45346 18.1404L7.46059 18V10.8C7.46059 10.4817 7.35331 10.1765 7.16237 9.95147C6.97142 9.72643 6.71244 9.6 6.4424 9.6ZM12.5515 9.6C12.2815 9.6 12.0225 9.72643 11.8315 9.95147C11.6406 10.1765 11.5333 10.4817 11.5333 10.8V18C11.5333 18.3183 11.6406 18.6235 11.8315 18.8485C12.0225 19.0736 12.2815 19.2 12.5515 19.2C12.8215 19.2 13.0805 19.0736 13.2715 18.8485C13.4624 18.6235 13.5697 18.3183 13.5697 18V10.8C13.5697 10.4817 13.4624 10.1765 13.2715 9.95147C13.0805 9.72643 12.8215 9.6 12.5515 9.6ZM11.8184 2.4H7.1755L6.83644 3.6H12.1575L11.8184 2.4Z" fill="#A9AABC"/>
                </svg>
                  {/* Sil */}
                </Button>
              </Stack>
              <Box sx={{ height: gridHeight, mt: 1 }}>
                <DataGrid rows={gridRows} columns={gridColumns} columnVisibilityModel={columnVisibilityModel}
                pageSize={20}
                checkboxSelection
                onSelectionModelChange={(ids) => {
                  this.setState({ selectedIds: ids});
                }}
                sx={{
                  // '& .MuiDataGrid-cell:hover': {
                  //   color: '#28a5ad',
                  // },
                  '& .MuiDataGrid-cell': styles.dataGrid
                }}
                components={{NoRowsOverlay:(params) => (<div></div>)}}
                />
                <div align="center">
                <Button size="small" onClick={this.handleAddRow} sx={styles.gridSaveBtn} className="customNewButton">
                  <svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 17 17" fill="none">
                    <path d="M15.3571 9.64286H9.64286V15.3571C9.64286 15.6602 9.52245 15.9509 9.30812 16.1653C9.0938 16.3796 8.80311 16.5 8.5 16.5C8.1969 16.5 7.90621 16.3796 7.69188 16.1653C7.47755 15.9509 7.35714 15.6602 7.35714 15.3571V9.64286H1.64286C1.33975 9.64286 1.04906 9.52245 0.834735 9.30812C0.620408 9.09379 0.5 8.80311 0.5 8.5C0.5 8.1969 0.620408 7.90621 0.834735 7.69188C1.04906 7.47755 1.33975 7.35714 1.64286 7.35714H7.35714V1.64286C7.35714 1.33975 7.47755 1.04906 7.69188 0.834735C7.90621 0.620407 8.1969 0.5 8.5 0.5C8.80311 0.5 9.0938 0.620407 9.30812 0.834735C9.52245 1.04906 9.64286 1.33975 9.64286 1.64286V7.35714H15.3571C15.6602 7.35714 15.9509 7.47755 16.1653 7.69188C16.3796 7.90621 16.5 8.1969 16.5 8.5C16.5 8.80311 16.3796 9.09379 16.1653 9.30812C15.9509 9.52245 15.6602 9.64286 15.3571 9.64286Z" fill="#18428F"/>
                  </svg> <span>Ekle</span>
                </Button>
                </div>
              </Box>
            </Box>
            }
          </div>
          <div>
          {isDialogOpen ?
          <EditDialog open = {isDialogOpen} text = '' title={dialogTitle} selectedData={selectedRowData} fields={gridColumns}
            onClose = {(e) => this.handleCloseDialog(e)} handleApprove = {(e) => this.handleApproveDialog(e)} />:null}

            <MUDialog open = {this.state.isDeleteDialogOpen} text = 'Silmek istediğinize emin misiniz?' title='Uyarı'
            onClose = {(e) => this.handleCloseDeleteDialog(e)} handleApprove = {(e) => this.handleApproveDeleteDialog(e)}/>
          </div>
        </div>
        
      );
  }
}